// @ts-nocheck
/* eslint-enable */
/* eslint-disable camelcase, dot-notation, max-len */
// Tracking scripts for HotPads marketing campaigns.
import constants from 'app/shared/constants/ConstantsBundle';
import { getGlobalLogger } from '@zg-rentals/logger-base';
import { logError } from '@zg-rentals/log-error';
const logger = getGlobalLogger('trackingUtils');

const trackingUtils = {
  rafAsync() {
    return new Promise((resolve) => {
      requestAnimationFrame(resolve); //faster than set time out
    });
  },

  /**
   * Get the active consent manager (DataGrail)
   */
  getConsentManager() {
    return 'datagrail';
  },

  /**
   * Utility function to wait for DataGrail consent manager to be initialized
   */
  checkConsentManager() {
    return trackingUtils.checkDataGrail();
  },

  /**
   * Utility function to wait for DataGrail to be initialized.
   * Polls for DataGrail with retry limits to prevent infinite loops.
   *
   * @param retryCount - Current retry attempt (internal, don't pass manually)
   * @param maxRetries - Maximum number of retries (default: 150 retries ~2.5s at 60fps)
   * @returns Promise that resolves to true when DataGrail is ready, rejects on timeout
   */
  checkDataGrail(retryCount = 0, maxRetries = 150) {
    // Check if we've exceeded max retries
    if (retryCount >= maxRetries) {
      const error = new Error(
        `DataGrail failed to load after ${maxRetries} retries (~${Math.round((maxRetries / 60) * 1000)}ms). It may be blocked by an ad blocker or failed to load.`,
      );
      logger?.warn('checkDataGrail timeout', { retryCount, maxRetries });
      return Promise.reject(error);
    }

    if (typeof window === 'undefined' || !window.DG_BANNER_API) {
      return trackingUtils.rafAsync().then(() => trackingUtils.checkDataGrail(retryCount + 1, maxRetries));
    } else {
      return Promise.resolve(true);
    }
  },

  indexAdWrapper: {
    appendScript() {
      return (dispatch) => {
        try {
          // DataGrail manages scripts via data-consent-id attributes in the HTML
          // The script is already in Body.js with proper attributes, so we just mark as initialized
          logger?.info('indexAdWrapper: Using DataGrail (script managed via HTML attributes)');
          dispatch({
            type: constants.SET_APP_STORE_BOOL,
            payload: {
              name: 'indexAdWrapperInit',
              bool: true,
            },
          });
        } catch (err) {
          logError({ error: err, context: 'Error loading indexAdWrapper in appendScript' });
        }
      };
    },
    discardScript() {
      return () => {
        const targetElement = document.getElementById('indexTracker');

        if (targetElement) {
          targetElement.remove();
        }
      };
    },
  },
  goog: {
    appendScript() {
      // Need to append Google Ad Services tracker if it isn't already on the page.
      if (!document.getElementById('google-ad-services')) {
        try {
          // DataGrail manages scripts via data-consent-id attributes in the HTML
          // The script is already in Body.js with proper attributes
          logger?.info('googleAdServices: Using DataGrail (script managed via HTML attributes)');
        } catch (err) {
          logError({ error: err, context: 'Error loading google ad services' });
        }
      }
    },
  },
  removeElementById(id) {
    const elem = document.getElementById(id);

    if (elem) {
      return elem.parentNode.removeChild(elem);
    }
  },
};

export default trackingUtils;
